import { computed, ref } from 'vue';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useTextCarousel = (props, { emit }) => {
  // ----------------------------------------
  // computed
  const leftArrowActive = computed((): boolean => {
    return !props.infinite ? props.activeSlide > 0 : true;
  });

  const rightArrowActive = computed((): boolean => {
    return !props.infinite
      ? props.activeSlide < props.options.length - 1
      : true;
  });

  // ----------------------------------------
  // methods
  const activeClass = (index: number, option: string): string => {
    if (
      (props.value && option === props.value) ||
      (!props.value && props.activeSlide === index)
    ) {
      return 'otb-text-carousel-option--active';
    }
    return '';
  };

  const choose = (dir: string): void => {
    const options = ref([]);
    let localActiveSlide = props.activeSlide;
    if (props.infinite) {
      if (dir === 'next') {
        if (localActiveSlide === options.value.length - 1) {
          localActiveSlide = 0;
        } else {
          localActiveSlide += 1;
        }
      } else if (localActiveSlide === 0) {
        localActiveSlide = options.value.length - 1;
      } else {
        localActiveSlide -= 1;
      }
    } else if (dir === 'next') {
      localActiveSlide += 1;
    } else {
      localActiveSlide -= 1;
    }
    emit('input', {
      text: props.options[localActiveSlide],
      index: localActiveSlide,
    });
  };

  const swipeHelperLeft = (): void => {
    if (leftArrowActive.value) {
      choose('prev');
    }
  };

  const swipeHelperRight = (): void => {
    if (rightArrowActive.value) {
      choose('next');
    }
  };

  return {
    activeClass,
    choose,
    leftArrowActive,
    rightArrowActive,
    swipeHelperLeft,
    swipeHelperRight,
  };
};

export default useTextCarousel;
